import { render, staticRenderFns } from "./CookiesPolicyView.vue?vue&type=template&id=3158abc4&scoped=true"
import script from "./CookiesPolicyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookiesPolicyView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CookiesPolicyView.vue?vue&type=style&index=0&id=3158abc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158abc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3158abc4')) {
      api.createRecord('3158abc4', component.options)
    } else {
      api.reload('3158abc4', component.options)
    }
    module.hot.accept("./CookiesPolicyView.vue?vue&type=template&id=3158abc4&scoped=true", function () {
      api.rerender('3158abc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LegalTexts/CookiesPolicyView.vue"
export default component.exports